import React from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import RemoveIcon from "@mui/icons-material/Remove";
import styles from "./Dashboard.module.scss";

/*
 * A single headline metric, rendered as a solid colour card — the original
 * dashboard treatment, kept because it is the established look of this page.
 *
 * The delta pairs an ARROW ICON with a signed label, never colour alone. On a
 * saturated background a red/green chip is both low-contrast and invisible to a
 * colour-blind reader, and this is financial data.
 */
const StatTile = ({ label, value, sublabel, delta, tone = "blue" }) => {
	const hasDelta = typeof delta === "number" && Number.isFinite(delta);
	const direction = !hasDelta ? "flat" : delta > 0.05 ? "up" : delta < -0.05 ? "down" : "flat";

	const DeltaIcon =
		direction === "up" ? ArrowUpwardIcon : direction === "down" ? ArrowDownwardIcon : RemoveIcon;

	return (
		<div className={`${styles.statTile} ${styles[`tone_${tone}`]}`}>
			<span className={styles.statLabel}>{label}</span>
			<span className={styles.statValue}>{value}</span>

			<span className={styles.statFooter}>
				{hasDelta ? (
					<span className={styles.statDelta}>
						<DeltaIcon fontSize="inherit" aria-hidden="true" />
						{direction === "flat" ? "no change" : `${Math.abs(delta).toFixed(1)}%`}
						<span className={styles.statDeltaContext}>vs last month</span>
					</span>
				) : (
					<span className={styles.statSublabel}>{sublabel}</span>
				)}
			</span>
		</div>
	);
};

export default StatTile;
